import styled from 'styled-components'

export default styled.div`  
  body {
    background-color: #D3D0CB;
    text-align: center;
  }
  .bottom-sheet-wrapper {
    -webkit-transition: opacity 500ms cubic-bezier(0.03, 0.72, 0.36, 0.99);
    -moz-transition: opacity 500ms cubic-bezier(0.03, 0.72, 0.36, 0.99);
    -ms-transition: opacity 500ms cubic-bezier(0.03, 0.72, 0.36, 0.99);
    -o-transition: opacity 500ms cubic-bezier(0.03, 0.72, 0.36, 0.99);
    transition: opacity 500ms cubic-bezier(0.03, 0.72, 0.36, 0.99);
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 998;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
  .bottom-sheet-wrapper .bottom-sheet-block-layer {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
  }
  .bottom-sheet-wrapper .bottom-sheet {
    -webkit-transition: transform 500ms cubic-bezier(0.03, 0.72, 0.36, 0.99);
    -moz-transition: transform 500ms cubic-bezier(0.03, 0.72, 0.36, 0.99);
    -ms-transition: transform 500ms cubic-bezier(0.03, 0.72, 0.36, 0.99);
    -o-transition: transform 500ms cubic-bezier(0.03, 0.72, 0.36, 0.99);
    transition: transform 500ms cubic-bezier(0.03, 0.72, 0.36, 0.99);
    -webkit-transform: translate3d(0px, 100%, 0);
    -moz-transform: translate3d(0px, 100%, 0);
    -ms-transform: translate3d(0px, 100%, 0);
    -o-transform: translate3d(0px, 100%, 0);
    transform: translate3d(0px, 100%, 0);
    position: absolute;
    bottom: 0px;
    z-index: 999;
    width: 100%;
    background-color: #fff;
  }
  .bottom-sheet-wrapper.hide {
    display: none;
  }
  .bottom-sheet-wrapper .bottom-sheet-item {
    display: block;
    width: 100%;
    background-color: #fff;
    text-align: center;
    padding: 20px 0;
    border: none;
    border-top: 1px solid #ededed;
    font-size: 16px;
  }
  .bottom-sheet-wrapper .bottom-sheet-item.cancel {
    color: #d0021b;
  }
  .bottom-sheet-wrapper .toast {
    bottom: 110%;
  }
  .bottom-sheet-wrapper.enter {
    opacity: 1;
  }
  .bottom-sheet-wrapper.enter .bottom-sheet {
    -webkit-transform: translate3d(0px, 0px, 0);
    -moz-transform: translate3d(0px, 0px, 0);
    -ms-transform: translate3d(0px, 0px, 0);
    -o-transform: translate3d(0px, 0px, 0);
    transform: translate3d(0px, 0px, 0);
  }
  .btn-container {
    padding: 10px;
    position: absolute;
    margin-bottom: 0;
    width: 100%;
    border-top: 1px solid #c7c7cc;

    .btn {
      width: 100%;
      height: 50px;
      color: #ffffff;
      border: none;
      background-color: #000000 !important;
      font-family: 'ABChanel PB Regular S', Arial, sans-serif;
      font-size: 12px !important;

      .add-to-bag-loading {
        margin: auto;
      }
    }
    bottom: 0;
    margin-bottom: env(safe-area-inset-bottom);
  }
`



// WEBPACK FOOTER //
// ./src/styles/BottomSheet.js